import { DEFAULT_LANGUAGE } from 'common/utils/constants'
import { getActiveLanguageCode } from 'common/utils/localeUtils'
import { getSupportedHelpPageLocaleLookup } from 'common/utils/context'

const HELP_ARTICLES = {
  HOME: 'home',
  ADVANCE_BOOKINGS: 'solutions/articles/22000237750-how-far-in-advance-can-i-book-',
  LOCATE_MY_POSITION: 'solutions/articles/22000239366-can-rome2rio-find-my-location-',
  UNDERSTAND_MY_ETICKET: 'solutions/articles/22000239380-can-you-help-me-understand-my-e-ticket-',
  TRAIN_REPLACES_BUS: 'solutions/articles/22000237748-why-has-my-train-been-replaced-with-a-bus-',
  NO_TICKETS: 'solutions/articles/22000280963-why-don-t-i-get-any-results-when-searching-for-a-ticket-',
}

const getHelpPageUrl = (helpArticle = HELP_ARTICLES.HOME) => {
  // Currently any language that has been enabled for use in tickets/checkout
  // should also be ready to be displayed in Freshdesk
  const languageCode = getHelpPageLanguageCode()
  return `https://help.rome2rio.com/${languageCode}/support/${helpArticle}`
}

const getHelpPageLanguageCode = () => {
  const languageCode = getActiveLanguageCode()
  const supportedLocaleLookup = getSupportedHelpPageLocaleLookup()
  if (supportedLocaleLookup && supportedLocaleLookup[languageCode]) {
    return supportedLocaleLookup[languageCode]
  }
  return DEFAULT_LANGUAGE
}

export {
  HELP_ARTICLES,
  getHelpPageUrl,
}
